
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import { Job } from '../../global/models'
import CustomerJobView from '../components/Read/CustomerJobView.vue'
import { consumeError } from '@/domains/global/utils'

const POLL_TIMEOUT = 3000

@Component({
  components: { CustomerJobView }
})
export default class JobReadPage extends Vue {
  job: Job | null = null

  error: string | null = null

  get jobId() {
    return this.$route.params.id
  }

  mounted() {
    this.getData()
  }

  async getData() {
    try {
      const response = await axios.get<Job>(`/jobs/${this.jobId}`)
      this.job = response.data

      if (!this.job.ready) {
        setTimeout(() => this.pollJob(), POLL_TIMEOUT)
      }
    } catch (error: any) {
      this.error = 'generic'
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async pollJob() {
    try {
      const response = await axios.get<Job>(`/jobs/${this.jobId}/poll`)
      if (response.data.ready) {
        await this.getData()
      } else {
        setTimeout(() => this.pollJob(), POLL_TIMEOUT)
      }
    } catch (error: any) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async unassignJob(job: Job) {
    try {
      await axios.post(`/jobs/${job.id}/unassign`)
      await this.getData()
    } catch (error: any) {
      this.error = 'generic'
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async saveJob(job: Job) {
    try {
      await axios.put(`/jobs/${this.jobId}`, job)
      await this.getData()
    } catch (error: any) {
      this.error = 'generic'
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async abandonJob(data: { job: Job, reason: string }) {
    try {
      await axios.put(`jobs/${data.job.id}/abandon`, { reason: data.reason })
      await this.$store.dispatch('success', 'Job Abandoned')
      await this.getData()
    } catch (error: any) {
      this.error = 'generic'
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        await this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
